import { v_InvoiceNoteBus } from './v_InvoiceNoteBus';
import { Address } from './Address';
import { BaseBus } from './BaseBus';
import { v_InvoiceLineItemBus } from './v_InvoiceLineItemBus';
import { v_InvoiceDetailBus } from './v_InvoiceDetailBus';
import { InvoiceLineItemsSummary } from './InvoiceLineItemsSummary';
import { CommonFunctions } from '../static/common-functions';
import { TaxCodeBus } from './TaxCodeBus';
import { CustomPricingBus } from './CustomPricingBus';
import { InvoiceProfit } from './InvoiceProfit';

export class AdditionalInvoiceData extends BaseBus
{
    constructor(data: AdditionalInvoiceData = null) {
        super(data);
        if (data !== null) {
            this.detail = new v_InvoiceDetailBus(data.detail);
            this.address = new Address();
            this.address.set(this.detail.addressLine1, this.detail.addressLine2, this.detail.city, this.detail.stateProvince, this.detail.postalCode);
            this.billingAddress = new Address();
            this.billingAddress.set(this.detail.billingAddressLine1, this.detail.billingAddressLine2, this.detail.billingCity, this.detail.billingStateProvince, this.detail.billingPostalCode);
            let invLines = [];
            if (CommonFunctions.hasArrayValue(data.lineItems)) {
                for (let i = 0; i < data.lineItems.length; i++) {
                    let newObj: v_InvoiceLineItemBus = new v_InvoiceLineItemBus(data.lineItems[i]);

                    newObj.originalQuantity = newObj.quantity;
                    invLines.push(newObj);
                }
            }
            this.lineItems = invLines;
            let notes = [];
            if (CommonFunctions.hasArrayValue(data.notes)) {
                for (let i = 0; i < data.notes.length; i++) {
                    let newObj: v_InvoiceNoteBus = new v_InvoiceNoteBus(data.notes[i]);
                    notes.push(newObj);
                }
            }
            this.notes = notes;

            this.minProfit = data.minProfit;
            this.amountReceived = data.amountReceived;
            this.drawPartsIds = data.drawPartsIds;
            this.canSetSpcApprvdIfFtr = data.canSetSpcApprvdIfFtr;
            this.profit = new InvoiceProfit(data.profit);
      //      this.taxCode = new TaxCodeBus(data.taxCode);
        //    this.customPricing = new CustomPricingBus(data.customPricing);
        }
    }
    protected setAdditional(busObj: any) {
        if (!CommonFunctions.hasValue(this.lineItemsSummary)) {
            this.lineItemsSummary = new InvoiceLineItemsSummary();
        }
    }
    updateLines(data: AdditionalInvoiceData = null) {

        if (data !== null ) {
            let invLines = [];
            if (CommonFunctions.hasArrayValue(data.lineItems)) {
                for (let i = 0; i < data.lineItems.length; i++) {
                    let newObj: v_InvoiceLineItemBus = new v_InvoiceLineItemBus(data.lineItems[i]);

                    newObj.originalQuantity = newObj.quantity;
                    invLines.push(newObj);
                }
            }
            this.lineItems = invLines;
            //let notes = [];
            //if (CommonFunctions.hasArrayValue(data.notes)) {
            //    for (let i = 0; i < data.notes.length; i++) {
            //        let newObj: v_InvoiceNoteBus = new v_InvoiceNoteBus(data.notes[i]);
            //        notes.push(newObj);
            //    }
            //}
            //this.notes = notes;

            this.minProfit = data.minProfit;
            this.amountReceived = data.amountReceived;
            this.drawPartsIds = data.drawPartsIds;
            this.canSetSpcApprvdIfFtr = data.canSetSpcApprvdIfFtr;
            this.profit = new InvoiceProfit(data.profit);
            //      this.taxCode = new TaxCodeBus(data.taxCode);
            //    this.customPricing = new CustomPricingBus(data.customPricing);
        }
    }
    customerLocationCheck(customerId: any, locationId: any) {

    }
    clear() {
        this.detail = null;
        this.notes = null;
        this.lineItems = null;
        this.address = null;
        this.billingAddress = null;
        this.lineItemsSummary = null;
        this.minProfit = null;
        this.amountReceived = null;
        this.drawPartsIds = [];
        this.profit = new InvoiceProfit();
  //      this.taxCode = null;
    //    this.customPricing = null;
    }
    detail: v_InvoiceDetailBus;
    notes: v_InvoiceNoteBus[];
    lineItems: v_InvoiceLineItemBus[];
    address: Address;
    billingAddress: Address;
    lineItemsSummary: InvoiceLineItemsSummary;
    minProfit: number;
    amountReceived: number;
    drawPartsIds: any[];
//    taxCode: TaxCodeBus;
    customPricing: CustomPricingBus;
    canSetSpcApprvdIfFtr: boolean;
    creditMemoApprLimit: number;
    profit: InvoiceProfit;
    isWarranty: boolean;
}
